export default __webpack_public_path__ + "static/media/green-trane-BA-logos.ba54c614.svg";